module.exports = __webpack_public_path__ + "static/img/8.ae5e073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8.png
// module id = KNp8
// module chunks = 1